var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanaBazarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_shopping-bag",
    "data-name": "vuesax/linear/shopping-bag",
    transform: "translate(-686 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.92,0h7.2c3.4,0,3.74,1.59,3.97,3.53l.9,7.5c.29,2.46-.47,4.47-3.97,4.47H4.03C.52,15.5-.24,13.49.06,11.03l.9-7.5C1.18,1.59,1.52,0,4.92,0Z",
    transform: "translate(689.48 194.5)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,6V2.5A2.362,2.362,0,0,1,2.5,0h3A2.362,2.362,0,0,1,8,2.5V6",
    transform: "translate(694 190)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M12.41,0H0",
    transform: "translate(694 205.03)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(686 188)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanaBazarIcon);
export default __webpack_public_path__ + "static/media/danaBazarIcon.7b411ec28d86eaa35d4fdeda1fa68a19.svg";
export { ForwardRef as ReactComponent };